import { m } from 'framer-motion'
import Button from './Button'
import { Link } from 'react-router-dom'
import { REFRESH_APP_INFO, useApp } from '@/lib/provider/AppProvider'
import { useMutation } from '@tanstack/react-query'
import { AppService } from '@/lib/services/AppService'
import ChartBarIcon from '@icons/chart-bar'

const appService = new AppService()

export default function AnalyticsBox() {
  const [, dispatchApp] = useApp()

  const { mutate: updateAnalytics, isPending } = useMutation({
    mutationFn: async (enabled: boolean) => {
      await appService.updateAnalytics(enabled)
    },

    onSuccess: () => {
      dispatchApp({ type: REFRESH_APP_INFO })
    },
  })

  return (
    <m.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="fixed bottom-6 right-6 left-6 sm:right-auto sm:w-full sm:max-w-[400px] rounded-lg bg-white p-6 shadow-lg ring-1 ring-black/5 dark:bg-gray-900"
    >
      <div className="rounded-full bg-accent-10 p-2  absolute right-4 top-4">
        <ChartBarIcon className="size-5 text-accent-40" />
      </div>
      <div className="flex items-start gap-4 relative">
        <div className="flex-1">
          <h3 className="text-lg font-semibold text-brand-1 dark:text-white">
            Analytics Consent
          </h3>
          <p className="mt-2 text-sm text-gray-600 dark:text-gray-300">
            We'd like to collect usage data to improve your experience. This
            helps us understand how you use our product and make it better for
            everyone. You can always opt-out later in your settings.
            <Link to="/settings/analytics" className="ml-1 text-sm text-link  ">
              Learn more about our analytics
            </Link>
          </p>

          <div className="mt-6 flex gap-3 justify-stretch items-stretch w-full">
            <Button
              cy="analytics-accept"
              style="primary"
              onClick={() => updateAnalytics(true)}
              className="px-8"
              disabled={isPending}
            >
              Accept
            </Button>
            <Button
              cy="analytics-decline"
              style="normal"
              onClick={() => updateAnalytics(false)}
              className="px-8"
              disabled={isPending}
            >
              Decline
            </Button>
          </div>
        </div>
      </div>
    </m.div>
  )
}
